import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ListingContext = createContext();

const createDefaultListingState = () => ({
  category: '',
  fromAddress: '',
  fromCity: '',
  fromRegion: '',
  fromCountry: '',
  fromPostcode: '',
  fromCoords: null,
  toAddress: '',
  toCity: '',
  toRegion: '',
  toCountry: '',
  toPostcode: '',
  toCoords: null,
  flexiblePickup: true,
  flexibleDelivery: true,
  pickupDateFrom: null,
  pickupDateTo: null,
  deliveryDateFrom: null,
  deliveryDateTo: null,
  items: [{}],
  clientType: 'private',
  companyCountry: '',
  allowsQuotes: true,
  clientPriceGross: '',
  description: '',
  images: [],
  draftListingId: null,
  uploadedImageDocs: [],
  title: '',
});

export const ListingProvider = ({ children }) => {
  const [listingData, setListingData] = useState(createDefaultListingState);
  const [currentStep, setCurrentStep] = useState(1);

  const updateListing = useCallback((updates) => {
    setListingData((prev) => ({ ...prev, ...updates }));
  }, []);

  const resetListing = useCallback(() => {
    setListingData(createDefaultListingState());
    setCurrentStep(1);
  }, []);

  const value = useMemo(() => ({
    listingData,
    currentStep,
    setCurrentStep,
    updateListing,
    resetListing,
  }), [listingData, currentStep, updateListing, resetListing]);

  return (
    <ListingContext.Provider value={value}>
      {children}
    </ListingContext.Provider>
  );
};

export const useListing = () => {
  const context = useContext(ListingContext);
  if (!context) throw new Error('useListing must be used within ListingProvider');
  return context;
};

export default ListingContext;
